// src/pages/bloomterminal/alerts/components/ToggleSwitch.jsx
import React, { useState } from 'react';

const ToggleSwitch = ({ enabled, onToggle, disabled = false }) => {
  const [isPressed, setIsPressed] = useState(false);

  const handleMouseDown = () => {
    if (!disabled) setIsPressed(true);
  };

  const handleMouseUp = () => {
    setIsPressed(false);
  };

  const handleMouseLeave = () => {
    setIsPressed(false);
  };

  const handleClick = (e) => {
    if (!disabled) {
      onToggle(e);
    }
  };

  return (
    <button
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
      disabled={disabled}
      className={`relative h-[31px] w-[51px] rounded-full focus:outline-none focus:ring-2 focus:ring-bloom-green focus:ring-offset-2 focus:ring-offset-black active:scale-95 transition-transform duration-150 ${
        disabled ? 'cursor-not-allowed opacity-60' : ''
      }`}
      role="switch"
      aria-checked={enabled}
    >
      {/* Background */}
      <div
        className={`absolute inset-0 rounded-full transition-colors duration-300 ease-in-out ${
          enabled ? 'bg-bloom-green' : 'bg-[#5d625f]'
        }`}
      />
      
      {/* Knob */}
      <span
        className={`absolute top-1/2 h-[27px] w-[27px] rounded-full bg-white ${
          enabled 
            ? 'left-[calc(100%-27px-2px)]' 
            : 'left-[2px]'
        }`}
        style={{
          transform: `translateY(-50%) ${isPressed ? 'scale(0.9)' : 'scale(1)'}`,
          transition: 'left 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.15s ease-out, box-shadow 0.3s ease-in-out',
          boxShadow: enabled 
            ? '0 0 0 1px rgba(21, 203, 94, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1)' 
            : '0 2px 4px rgba(0, 0, 0, 0.1)'
        }}
      />
    </button>
  );
};

export default ToggleSwitch;

